module.exports = __webpack_public_path__ + "img/cranial_nerves_gray.ffc6e029.png";